/** Presets for the fabric vendor public page (`PublicFabricView`). Applied via CSS variables on the page root. */

export const PUBLIC_VENDOR_THEME_IDS = ['indigo', 'noir', 'rose', 'forest', 'sand', 'ocean'];

const THEME_VARS = {
  indigo: {
    '--pv-page-from': '#eff6ff',
    '--pv-page-via': '#eef2ff',
    '--pv-page-to': '#faf5ff',
    '--pv-primary': '#9333ea',
    '--pv-primary-hover': '#7e22ce',
    '--pv-secondary': '#4f46e5',
    '--pv-hero-from': '#9333ea',
    '--pv-hero-via': '#4f46e5',
    '--pv-hero-to': '#2563eb',
    '--pv-tab-ring': '#f3e8ff',
    '--pv-card-border': '#ede9fe',
    '--pv-tab-inactive': '#6b21a8',
    '--pv-tab-inactive-hover-bg': '#faf5ff',
    '--pv-badge-secondary': '#3b82f6',
    '--pv-collection-from': 'rgba(147, 51, 234, 0.12)',
    '--pv-collection-via': 'rgba(236, 72, 153, 0.12)',
    '--pv-collection-to': 'rgba(79, 70, 229, 0.12)',
    '--pv-tag-bg': '#f3e8ff',
    '--pv-tag-text': '#7e22ce',
  },
  noir: {
    '--pv-page-from': '#f8fafc',
    '--pv-page-via': '#f1f5f9',
    '--pv-page-to': '#e2e8f0',
    '--pv-primary': '#4f46e5',
    '--pv-primary-hover': '#4338ca',
    '--pv-secondary': '#64748b',
    '--pv-hero-from': '#0f172a',
    '--pv-hero-via': '#312e81',
    '--pv-hero-to': '#1e1b4b',
    '--pv-tab-ring': '#e2e8f0',
    '--pv-card-border': '#e2e8f0',
    '--pv-tab-inactive': '#475569',
    '--pv-tab-inactive-hover-bg': '#f8fafc',
    '--pv-badge-secondary': '#6366f1',
    '--pv-collection-from': 'rgba(15, 23, 42, 0.08)',
    '--pv-collection-via': 'rgba(79, 70, 229, 0.1)',
    '--pv-collection-to': 'rgba(51, 65, 85, 0.08)',
    '--pv-tag-bg': '#e0e7ff',
    '--pv-tag-text': '#3730a3',
  },
  rose: {
    '--pv-page-from': '#fff1f2',
    '--pv-page-via': '#ffe4e6',
    '--pv-page-to': '#fdf2f8',
    '--pv-primary': '#e11d48',
    '--pv-primary-hover': '#be123c',
    '--pv-secondary': '#db2777',
    '--pv-hero-from': '#be123c',
    '--pv-hero-via': '#db2777',
    '--pv-hero-to': '#a21caf',
    '--pv-tab-ring': '#fecdd3',
    '--pv-card-border': '#fecdd3',
    '--pv-tab-inactive': '#9f1239',
    '--pv-tab-inactive-hover-bg': '#fff1f2',
    '--pv-badge-secondary': '#f472b6',
    '--pv-collection-from': 'rgba(225, 29, 72, 0.1)',
    '--pv-collection-via': 'rgba(219, 39, 119, 0.1)',
    '--pv-collection-to': 'rgba(162, 28, 175, 0.08)',
    '--pv-tag-bg': '#fce7f3',
    '--pv-tag-text': '#9d174d',
  },
  forest: {
    '--pv-page-from': '#ecfdf5',
    '--pv-page-via': '#d1fae5',
    '--pv-page-to': '#f0fdf4',
    '--pv-primary': '#059669',
    '--pv-primary-hover': '#047857',
    '--pv-secondary': '#0d9488',
    '--pv-hero-from': '#047857',
    '--pv-hero-via': '#0d9488',
    '--pv-hero-to': '#0f766e',
    '--pv-tab-ring': '#a7f3d0',
    '--pv-card-border': '#a7f3d0',
    '--pv-tab-inactive': '#065f46',
    '--pv-tab-inactive-hover-bg': '#ecfdf5',
    '--pv-badge-secondary': '#14b8a6',
    '--pv-collection-from': 'rgba(5, 150, 105, 0.12)',
    '--pv-collection-via': 'rgba(13, 148, 136, 0.1)',
    '--pv-collection-to': 'rgba(4, 120, 87, 0.08)',
    '--pv-tag-bg': '#d1fae5',
    '--pv-tag-text': '#047857',
  },
  sand: {
    '--pv-page-from': '#fffbeb',
    '--pv-page-via': '#fef3c7',
    '--pv-page-to': '#fafaf9',
    '--pv-primary': '#d97706',
    '--pv-primary-hover': '#b45309',
    '--pv-secondary': '#b45309',
    '--pv-hero-from': '#b45309',
    '--pv-hero-via': '#d97706',
    '--pv-hero-to': '#78716c',
    '--pv-tab-ring': '#fde68a',
    '--pv-card-border': '#fde68a',
    '--pv-tab-inactive': '#92400e',
    '--pv-tab-inactive-hover-bg': '#fffbeb',
    '--pv-badge-secondary': '#ca8a04',
    '--pv-collection-from': 'rgba(217, 119, 6, 0.12)',
    '--pv-collection-via': 'rgba(180, 83, 9, 0.1)',
    '--pv-collection-to': 'rgba(120, 113, 108, 0.1)',
    '--pv-tag-bg': '#fef3c7',
    '--pv-tag-text': '#b45309',
  },
  ocean: {
    '--pv-page-from': '#ecfeff',
    '--pv-page-via': '#e0f2fe',
    '--pv-page-to': '#f0f9ff',
    '--pv-primary': '#0284c7',
    '--pv-primary-hover': '#0369a1',
    '--pv-secondary': '#0ea5e9',
    '--pv-hero-from': '#0369a1',
    '--pv-hero-via': '#0284c7',
    '--pv-hero-to': '#0e7490',
    '--pv-tab-ring': '#bae6fd',
    '--pv-card-border': '#bae6fd',
    '--pv-tab-inactive': '#0c4a6e',
    '--pv-tab-inactive-hover-bg': '#ecfeff',
    '--pv-badge-secondary': '#06b6d4',
    '--pv-collection-from': 'rgba(2, 132, 199, 0.12)',
    '--pv-collection-via': 'rgba(14, 165, 233, 0.1)',
    '--pv-collection-to': 'rgba(14, 116, 144, 0.1)',
    '--pv-tag-bg': '#e0f2fe',
    '--pv-tag-text': '#0369a1',
  },
};

export const VENDOR_THEME_OPTIONS = [
  { id: 'indigo', name: 'Indigo Bloom', description: 'Purple & blue — default Fashdeck look' },
  { id: 'noir', name: 'Midnight Loom', description: 'Slate neutrals with indigo accents' },
  { id: 'rose', name: 'Rose Atelier', description: 'Warm rose and magenta hero' },
  { id: 'forest', name: 'Forest Loom', description: 'Emerald and teal' },
  { id: 'sand', name: 'Sand & Amber', description: 'Earthy gold and stone' },
  { id: 'ocean', name: 'Ocean Bolt', description: 'Sky blue and cyan' },
];

export function normalizePublicVendorThemeId(id) {
  if (id && PUBLIC_VENDOR_THEME_IDS.includes(id)) return id;
  return 'indigo';
}

export function getVendorThemeCssVars(themeId) {
  const key = normalizePublicVendorThemeId(themeId);
  return THEME_VARS[key] || THEME_VARS.indigo;
}
